import { useState } from 'react'

const SUN_PATTERN = [
  '0000000000000000',
  '0000000100000000',
  '0010000100000100',
  '0001000000001000',
  '0000001111000000',
  '0000011111100000',
  '0000111111110000',
  '0110111111110110',
  '0000111111110000',
  '0000011111100000',
  '0000001111000000',
  '0001000000001000',
  '0010000100000100',
  '0000000100000000',
  '0000000000000000',
  '0000000000000000',
]

const MOON_PATTERN = [
  '0000001111100000',
  '0000111111000000',
  '0001111110000000',
  '0011111000000000',
  '0111110000000000',
  '0111100000000000',
  '1111100000000000',
  '1111100000000000',
  '1111100000000000',
  '1111100000000000',
  '0111100000000000',
  '0111110000000000',
  '0011111000000000',
  '0001111110000000',
  '0000111111000000',
  '0000001111100000',
]

function getInitialTheme() {
  return document.documentElement.classList.contains('dark') ? 'dark' : 'light'
}

function PixelIcon({ pattern, className }) {
  return (
    <span className={`theme-pixel-icon ${className}`} aria-hidden="true">
      {pattern.join('').split('').map((pixel, index) => (
        <span key={index} className={pixel === '1' ? 'theme-pixel-bead' : 'theme-pixel-space'} />
      ))}
    </span>
  )
}

export default function ThemeToggle() {
  const [theme, setTheme] = useState(getInitialTheme)
  const isDark = theme === 'dark'

  const toggleTheme = () => {
    const next = isDark ? 'light' : 'dark'
    const root = document.documentElement
    root.classList.toggle('dark', next === 'dark')
    root.dataset.theme = next

    try {
      localStorage.setItem('doutian-theme', next)
    } catch {
      // The visual switch still works when storage is unavailable.
    }

    const themeColor = document.head.querySelector('meta[name="theme-color"]')
    if (themeColor) themeColor.setAttribute('content', next === 'dark' ? '#1B1F1D' : '#FF9AA2')
    setTheme(next)
  }

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className="theme-toggle"
      data-mode={theme}
      aria-label={isDark ? '切换到日间模式' : '切换到夜间模式'}
      title={isDark ? '日间模式' : '夜间模式'}
    >
      <PixelIcon pattern={SUN_PATTERN} className="theme-pixel-sun" />
      <PixelIcon pattern={MOON_PATTERN} className="theme-pixel-moon" />
    </button>
  )
}
